export default __webpack_public_path__ + "static/media/indicator_registers.d4c3c7d5.svg";